module.exports = __webpack_public_path__ + "img/logo-dt.39a54e0d.png";